import {ProductReviewResponseDTO} from "@shared/DTO/ProductReviewResponseDTO";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import {NAMES} from "@/scripts/components/review-list/constants/reviewList.constants";
import {ProductResponseDTO} from "@shared/DTO";
import {ProductTypeEnum} from "@shared/enums";
import {grammarFor} from "@shared/utils/grammar.utils";

const LIST_CLASS = NAMES.EL_LIST;
const ITEM_CLASS = NAMES.EL_ITEM;

export function getElList() {
  return createDomElementHandler("ul", `${LIST_CLASS}`, {role: "list"});
}

export function getIntro(
  product: ProductResponseDTO,
  reviews:  ProductReviewResponseDTO[]
){

  const reviewCount = reviews?.length || 0;
  const productType = product.productData.productType;
  const productName = product.productData.names?.at(0);
  const grammar = grammarFor(product);

  const heading = createDomElementHandler('h2', 'ab-user-review__intro');
  heading.textContent = `${productName}: opinioni dei nostri utenti`;

  const paragraph = createDomElementHandler('p', 'ab-user-review__intro-text');

  if(reviewCount > 0) {
    const reviewsAverage = (reviews?.reduce((acc, review) => acc + review.rating, 0) / (reviewCount || 1)).toFixed(2);
    paragraph.innerHTML = `I nostri utenti hanno finora lasciato ${reviewCount} ${reviewCount === 1 ? 'recensione' : 'recensioni'} ` +
    `${grammar.prep.di} ${productName}, con una valutazione media di <strong>${reviewsAverage} su 5</strong>.`;
    return {heading, paragraph};
  }

  paragraph.innerHTML = `Non è ancora presente nessuna <strong>recensione ${grammar.prep.di} ${productName}</strong>. Se possiedi o hai avuto modo di provare ` +
    `${productType === ProductTypeEnum.OBIETTIVO ? 'questo obiettivo' : 'questa fotocamera'}, usa il form qui sotto per condividere la tua esperienza ` +
    `con gli altri utenti.`;

  return {heading, paragraph};
}

const getElRatingRowItem = (rating: number) => {
  const wrapperEl = createDomElementHandler("div", `${ITEM_CLASS}__rating`);
  const labelEl = createDomElementHandler("span", `${ITEM_CLASS}__label`);
  const valueEl = createDomElementHandler("span", `${ITEM_CLASS}__value`);
  const textEl = createDomElementHandler("span", `${ITEM_CLASS}__text`);
  labelEl.textContent = "Voto: ";
  textEl.textContent = `(${rating}/5)`;
  valueEl.append(createDomElementHandler("ab-stars", [], {rating: rating.toString()}));
  wrapperEl.append(labelEl, valueEl, textEl);
  return wrapperEl;
}


export function getElReviewItem(review: ProductReviewResponseDTO) {
  const li = createDomElementHandler("li", `${ITEM_CLASS}`, { role: "listitem" });
  const header = createDomElementHandler("div", `${ITEM_CLASS}__header`);
  const name = createDomElementHandler("strong", `${ITEM_CLASS}__author`);
  name.textContent = review.authorName;
  const date = createDomElementHandler("time", `${ITEM_CLASS}__date`, {datetime: review.dateShown});
  date.textContent = new Date(review.dateShown).toLocaleDateString();
  const rating = getElRatingRowItem(review.rating);
  const content = createDomElementHandler("p", `${ITEM_CLASS}__content`);
  content.textContent = review.content;
  header.append(name, " · ", date, rating);
  li.append(header, content);
  return li;
}